/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Shop_Home_Story_Image_NInputs */

const vi_shop_home_story_image_n = /** @type {(inputs: Shop_Home_Story_Image_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ảnh câu chuyện ${i?.n}`)
};

/**

* @param {Shop_Home_Story_Image_NInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_story_image_n = /** @type {((inputs: Shop_Home_Story_Image_NInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Story_Image_NInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_story_image_n(inputs)
});